import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconYoutube = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 36 36"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <path d="M14.8 22.7165V13.2835L23.12 18L14.8 22.7165Z" fill="white"/>
        <path
            d="M33.3249 10.4347C33.1428 9.77025 32.7862 9.16443 32.2908 8.67788C31.7955 8.19132 31.1787 7.84109 30.5022 7.66225C28.0109 7 18 7 18 7C18 7 7.98911 7 5.49781 7.66225C4.82133 7.84109 4.20453 8.19132 3.70915 8.67788C3.21378 9.16443 2.8572 9.77025 2.67511 10.4347C2.20993 12.9302 1.98419 15.4631 2.00086 18C1.98419 20.5369 2.20993 23.0698 2.67511 25.5653C2.8572 26.2298 3.21378 26.8356 3.70915 27.3221C4.20453 27.8087 4.82133 28.1589 5.49781 28.3378C7.98911 29 18 29 18 29C18 29 28.0109 29 30.5022 28.3378C31.1787 28.1589 31.7955 27.8087 32.2908 27.3221C32.7862 26.8356 33.1428 26.2298 33.3249 25.5653C33.7901 23.0698 34.0158 20.5369 33.9991 18C34.0158 15.4631 33.7901 12.9302 33.3249 10.4347ZM14.8002 22.7143V13.2857L23.1083 18L14.8002 22.7143Z"
            fill="currentColor"/>
      </svg>
  )
}

TLIconYoutube.defaultProps = {
  className: '',
  height: 36,
  width: 36,
  tooltip: null
}
